export default __webpack_public_path__ + "static/media/referral.b7b83397.svg";